import environment from '../../.env.js';

const apiUrl = environment && environment.apiUrl ? environment.apiUrl : 'http://localhost:1337';

export { apiUrl };
